import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import { Button, Form } from "react-bootstrap";

const TimeslotPhysician = ({
  modalIsOpen,
  setModalIsOpen,
  selectedPeriod,
  activeTab,
  slotFormData,
  setSlotFormData,
  handleSlotChange,
  handleSlotSave,
}) => {
  const dayList = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const periodList = ["Morning", "Before Noon", "After Noon", "Evening"];

  const [toTimeError, setToTimeError] = useState("");
  const [slotDurationError, setSlotDurationError] = useState("");

  const handleToTimeBlur = () => {
    if (slotFormData.toTime <= slotFormData.fromTime) {
      setToTimeError("To time must be greater than from time.");
    } else {
      setToTimeError("");
    }
  };

  const handleSlotDurationBlur = () => {
    const fromTime = new Date(`1970-01-01T${slotFormData.fromTime}:00`);
    const toTime = new Date(`1970-01-01T${slotFormData.toTime}:00`);
    const availableMinutes = (toTime - fromTime) / (1000 * 60);

    if (slotFormData.slotDuration > availableMinutes) {
      setSlotDurationError(`Slot duration cannot exceed ${availableMinutes} minutes.`);
    } else {
      setSlotDurationError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!toTimeError && !slotDurationError) {
      await handleSlotSave(e);
      setModalIsOpen(false);
      setSlotFormData({
        clinicId: slotFormData?.clinicId,
        clinicName: slotFormData?.clinicName,
        clinicUserId: slotFormData?.clinicUserId,
        physicianId: "",
        id: "",
        slot: "",
        fromTime: "",
        toTime: "",
        dayName: slotFormData?.dayName || "Monday",
        sessionName: slotFormData?.sessionName || "Morning",
        slotDuration: null,
        waitingTime: null,
        consultationType: "",
      });
    }
  };

  return (
    <>
      <Modal centered show={modalIsOpen} onHide={() => setModalIsOpen(false)} size="md">
        <div className="modal-header">
          <h5 className="modal-title">
            Add Timeslot for {selectedPeriod} on {activeTab}
          </h5>
          <button type="button" className="btn-close" onClick={() => setModalIsOpen(false)}></button>
        </div>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="dayName" className="col-form-label">Day:</label>
                  <select
                    className="form-control"
                    id="dayName"
                    name="dayName"
                    value={slotFormData?.dayName}
                    onChange={handleSlotChange}
                  >
                    {dayList?.map((day, i) => (
                      <option key={i} value={day}>{day}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="period" className="col-form-label">Period:</label>
                  <select
                    className="form-control"
                    id="period"
                    name="sessionName"
                    value={slotFormData?.sessionName}
                    onChange={handleSlotChange}
                  >
                    {periodList?.map((period, j) => (
                      <option key={j} value={period}>{period}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label htmlFor="fromTime" className="col-form-label">From:</label>
                  <input
                    type="time"
                    className="form-control"
                    id="fromTime"
                    name="fromTime"
                    value={slotFormData?.fromTime}
                    onChange={handleSlotChange}
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label htmlFor="toTime" className="col-form-label">To:</label>
                  <input
                    type="time"
                    className="form-control"
                    id="toTime"
                    name="toTime"
                    value={slotFormData?.toTime}
                    onChange={handleSlotChange}
                    onBlur={handleToTimeBlur}
                  />
                  {toTimeError && <div className="text-danger mt-1">{toTimeError}</div>}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="slotDuration" className="col-form-label">Slot Duration:</label>
                  <input
                    type="number"
                    className="form-control"
                    id="slotDuration"
                    name="slotDuration"
                    value={slotFormData?.slotDuration}
                    onChange={handleSlotChange}
                    onBlur={handleSlotDurationBlur}
                  />
                  {slotDurationError && <div className="text-danger mt-1">{slotDurationError}</div>}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="waitingTime" className="col-form-label">Waiting Time:</label>
                  <input
                    type="number"
                    className="form-control"
                    id="waitingTime"
                    name="waitingTime"
                    value={slotFormData?.waitingTime}
                    onChange={handleSlotChange}
                  />
                </div>
              </div>
              <div className="col-xl-12">
                <div className="form-group">
                  <label htmlFor="consultationType" className="col-form-label">Consultation Type:</label>
                  <select
                    className="form-control"
                    id="consultationType"
                    name="consultationType"
                    value={slotFormData?.consultationType}
                    onChange={handleSlotChange}
                  >
                    <option value="">Select Consultation Type</option>
                    <option value="Clinic Visit">Clinic Visit</option>
                    <option value="Video Consultation">Video Consultation</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="form-group text-end">
              <Button type="button" variant="secondary" onClick={() => setModalIsOpen(false)}>Cancel</Button>
              <Button type="submit" variant="primary" className="ms-2">Save</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};
 
export default TimeslotPhysician;
